import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Layout from './Components/Layout/Layout';
import Home from './Pages/Home';
import PostDetails from './Pages/PostDetails';
import PageNotFound from './Components/404/PageNotFound';
import DoctorProfilePage from './Pages/DoctorProfilePage';
import PrivacyPolicyPage from './Pages/PrivacyPolicyPage';
import CookiePolicyPage from './Pages/CookiePolicyPage';
import ImprintPage from './Pages/ImprintPage';
import TermsConditionsPage from './Pages/TermsConditionsPage';
import { LanguageProvider } from './contexts/LanguageContext';
import { CookieConsentProvider } from './contexts/CookieConsentContext';
import CookieBanner from './Components/CookieConsent/CookieBanner';
import CookieSettings from './Components/CookieConsent/CookieSettings';
import DoctorsSurveyPage from './Pages/DoctorsSurveyPage';

const App = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <HelmetProvider>
      <LanguageProvider>
        <CookieConsentProvider>
          <CookieBanner />
          <CookieSettings />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="/doctor-profile" element={<DoctorProfilePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route path="/imprint" element={<ImprintPage />} />
              <Route path="/terms-conditions" element={<TermsConditionsPage />} />
              <Route path="post/:postId" element={<PostDetails />} />
              <Route path="/doctors-survey" element={<DoctorsSurveyPage />} />
              <Route path="*" element={<PageNotFound />} />

            </Route>
          </Routes>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </CookieConsentProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
};

export default App;
